module.exports = __webpack_public_path__ + "static/media/barrel-feta.633046f4.jpg";